import { render } from "./OrderComment.vue?vue&type=template&id=4bfed7de"
import script from "./OrderComment.vue?vue&type=script&lang=js"
export * from "./OrderComment.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__